import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { showToast } from "src/componentes";
import { AutenticacaoModule } from "src/Contexto/auth";

export const InicioCode = () => {
  const { empresaId } = AutenticacaoModule();
  const navigate = useNavigate();

  useEffect(() => {
    const Load = async () => {
      if (empresaId === 0) {
        showToast({
          message: "Efetue o cadastro de sua empresa",
          title: "Atenção",
          variant: "Warning",
        });
        navigate("/entidade/empresa");
      }
    };

    Load();
  }, []);

  return {};
};
